import React, { useState } from "react";
import { connect } from 'react-redux';
import { createStructuredSelector } from "reselect";
import { isEqual } from "lodash";

import { actions } from "store/users";
import { actions as enclosureActions } from 'features/Model/Enclosure/_ducks';

import { useStateSelector } from "utils/field";
import { standardCodeFormName, uDefCodeFormName } from "utils/codeLib";

import Button from "components/Button";
import Tooltip from "components/Tooltip";
import Dialog, { CloseDialog } from "components/Dialog";

import classes from "../style.module.scss";

import Edit from "assets/images/icons/JSX/Edit";
import Duplicate from "assets/images/icons/JSX/Duplicate";
import Delete from "assets/images/icons/JSX/Delete";

const { deleteCode } = actions;
const { setInitCode } = enclosureActions;

const CodeActions = React.memo(
    ({
        type,
        id,
        name,
        toggleComponentType,
        toggleCodeType,
        toggleOpenCreate,
        handleEditOpen,
        deleteCode,
        setInitCode,
    }) => {
        const [deleteOpen, toggleDeleteOpen] = useState(false);

        const { codeLib = {}, uid } = useStateSelector(`user`);

        const initCode = codeLib[type]?.codes[id] || {};

        const { componentType = "" } = initCode;

        const code = {
            codeRef: id,
            ...initCode
        };

        const [standardCode] = id.split(`${type}-U-`);

        const codeType = standardCode ? "S" : "U";

        const handleDuplicate = async () => {
            const codeName =
                codeType === "S"
                    ? standardCodeFormName(componentType)
                    : uDefCodeFormName(componentType);
            const { codeRef, label, ...restOfCode } = code;

            toggleComponentType(componentType);
            toggleCodeType(codeType);
            await setInitCode(
                { label: `${label} (Duplicate)`, ...restOfCode },
                codeName
            );
            toggleOpenCreate(true);
        };

        return (
            <div className={classes.actions}>
                <div
                    data-for={`${id}-actions`}
                    data-tip="Edit Code"
                    className={classes.action}
                    onClick={() =>
                        handleEditOpen(id, code, componentType, codeType)
                    }
                >
                    <Edit />
                </div>
                <div
                    data-for={`${id}-actions`}
                    data-tip="Duplicate Code"
                    className={classes.action}
                    onClick={handleDuplicate}
                >
                    <Duplicate />
                </div>
                <div
                    data-for={`${id}-actions`}
                    data-tip="Delete Code"
                    className={classes.action}
                    onClick={() => toggleDeleteOpen(true)}
                >
                    <Delete />
                </div>
                <Tooltip delay id={`${id}-actions`} />
                <Dialog open={!!deleteOpen}>
                    <CloseDialog closeActions={() => toggleDeleteOpen(false)} />
                    <div className={classes.dialog}>
                        <h3>
                            Are you sure you want to delete{" "}
                            <strong>{name}</strong>?
                        </h3>
                        <div className={classes.footer}>
                            <Button
                                onClick={() => toggleDeleteOpen(false)}
                                type="hollow"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    deleteCode(uid, id, type);
                                    toggleDeleteOpen(false);
                                }}
                                type="red"
                            >
                                Delete
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    },
    isEqual
);

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({
    deleteCode: (uid, id, type) => dispatch(deleteCode(uid, id, type)),
    setInitCode: (code, type) => {
        return dispatch(setInitCode(code, type));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CodeActions);